import React, { useState } from 'react';
import { Button } from './Button';
import { ModalContentWrapper } from './ModalContentWrapper';

export interface ConfirmModalProps {
  open: boolean;
  title: string | React.ReactNode | JSX.Element;
  content?: string;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  closeAfterConfirm?: boolean;
}

export const ConfirmModal = ({
  open,
  onClose,
  onConfirm,
  title,
  content,
  closeAfterConfirm = true,
}: ConfirmModalProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    let error = false;
    try {
      setIsLoading(true);

      await onConfirm();
    } catch (e) {
      error = true;
    } finally {
      setIsLoading(false);

      if (closeAfterConfirm === true && !error) {
        onClose();
      }
    }
  };

  return (
    <ModalContentWrapper open={open} title={title} onClose={onClose}>
      {content && <p className="pb-3">{content}</p>}
      <div className="w-full flex items-center space-x-6">
        <Button variant="secondary" onClick={onClose}>
          No
        </Button>
        <Button onClick={handleConfirm} loading={isLoading} disabled={isLoading}>
          Yes
        </Button>
      </div>
    </ModalContentWrapper>
  );
};
